import SelectField from '@pelckmans/elementis/components/select-field';
import { useTranslation } from 'react-i18next';
import { useResultsDataContext } from '../../../context/ResultsDataContext';
import { useFilters } from '../../../context/filter-context/FilterContext';

export default function ModuleFilter() {
  const { t } = useTranslation();
  const { selectedModule, setSelectedModule } = useFilters();
  const { modules } = useResultsDataContext();

  return (
    <SelectField
      value={selectedModule || null}
      onChange={setSelectedModule}
      renderValueContent={module => module.niceName}
      required
      size="sm"
      aria-label={t('PAGES.RESULTS.FILTERS.MODULE_FILTER.A11Y_LABEL')}
      dropdownMenuProps={{
        ariaLabel: t('PAGES.RESULTS.FILTERS.MODULE_FILTER.DROPDOWN_MENU.A11Y_LABEL'),
      }}
    >
      {modules.map(module => (
        <SelectField.Item value={module} text={module.niceName} key={module.id} />
      ))}
    </SelectField>
  );
}
